var Model = require("../types/Model.js");
var Promise = require("promise");
var window = require("global");
var InfoGetter = window.InfoGetter;
var uuid = require("uuid").v4;
// eslint-disable-next-line node/no-missing-require
const AsyncStorage = require("@react-native-async-storage/async-storage").default;

var RETRY_DELAY = 256; // About a quarter of a second
var SERIAL_KEY = "MACHINE_SERIAL";

module.exports = Model({
	name: "machinetracker",
	init: init,
	uninit: uninit,
	triggers: triggers,

	_trigger_queue: null
});

function init() {
	this._trigger_queue = [];
	get_info().then(handle_info.bind(this)).catch(console.error.bind(console));
}

function uninit() {
	this._trigger_queue = null;
}

function handle_info(info) {
	var data = info.split(" ");
	var serial = data[0];
	var apk = data[1];

	this.push({
		serial: serial,
		apk: apk,
		token: undefined
	});

	this._trigger_queue.forEach(re_trigger, this);
	this._trigger_queue = [];
}

function re_trigger(trigger) {
	var trigger_fn;

	if (trigger.type === "associate")
		trigger_fn = handle_trigger_associate;
	if (trigger.type === "state")
		trigger_fn = handle_trigger_state;
	if (trigger.type === "recover")
		trigger_fn = handle_trigger_recover;

	trigger_fn.call(this, trigger.data);
}

function triggers() {
	return {
		"associate": handle_trigger_associate,
		"state": handle_trigger_state,
		"recover": handle_trigger_recover
	};
}

function get_info() {
	if (InfoGetter) {
		return Promise.resolve(InfoGetter.get());
	}

	if (window.cordova) {
		if (window.plugins && window.plugins.uniqueDeviceID && window.cordova.getAppVersion) {
			return getInfoCordova();
		} else return get_again();
	}

	return getInfoDesktop();
}

function getInfoDesktop() {
	return AsyncStorage.getItem(SERIAL_KEY).then(function(serial){
		if (!serial) {
			serial = uuid();
			AsyncStorage.setItem(SERIAL_KEY, serial);
		}
		return serial + " desktop";
	});
}

function getInfoCordova() {
	return Promise.all([
		getSerialCordova(),
		getAPKCordova()
	]).then(function (results) {
		return results[0] + " " + results[1];
	});
}

function getSerialCordova() {
	return new Promise(function (resolve, reject) {
		window.plugins.uniqueDeviceID.get(resolve, reject);
	});
}

function getAPKCordova() {
	return new Promise(function (resolve, reject) {
		window.cordova.getAppVersion.getVersionNumber(resolve, reject);
	});
}

function handle_trigger_associate(data) {
	if (!this.data)
		return this._trigger_queue.push({
			type: "associate",
			data: data
		});

	var serial = this.data.serial;
	var apk = this.data.apk;
	if (!serial) return;
	if (!apk) return;

	this.api.machine.associate(serial, apk);
}

function handle_trigger_state(data) {
	if (!this.data)
		return this._trigger_queue.push({
			type: "state",
			data: data
		});

	var serial = this.data.serial;
	if (!serial) return;
	var state = data.state;
	this.api.machine.update(serial, state);
}

function handle_trigger_recover(data) {
	if (!this.data)
		return this._trigger_queue.push({
			type: "recover",
			data: data
		});

	var serial = this.data.serial;
	if (!serial) return;
	this.api.machine
		.token(serial)
		.then(handle_token_recovery.bind(this));
}

function handle_token_recovery(data) {
	var token = data.token;
	if (!token) return;
	this.extend({
		token: token
	});
}

function get_again() {
	return new Promise(function (resolve, reject) {
		setTimeout(function () {
			get_info().then(resolve).catch(reject);
		}, RETRY_DELAY);
	});
}
